import * as IconSelector from '../icons';

// Constantes exportadas
export const CONTACT_TYPE_REPRESENTANTE = 'Representante';
export const CONTACT_TYPE_AUTORIZADO = 'Autorizado';
export const CONTACT_TYPE_CONTACTO = 'Contacto';
export const CONTACT_TYPE_DIRECCION = 'Direccion';

// Definición del enum
export const contactType = [
    {
        value: CONTACT_TYPE_REPRESENTANTE,
        label: 'Representante',
        description: 'Representante',
        icon: IconSelector.RepresentativePersonIcon,
        color: 'Green'
    },
    {
        value: CONTACT_TYPE_AUTORIZADO,
        label: 'Autorizado',
        description: 'Autorizado',
        icon: IconSelector.AuthorizedPersonIcon,
        color: 'Red'
    },
    {
        value: CONTACT_TYPE_CONTACTO,
        label: 'Contacto',
        description: 'Comunidad de bienes',
        icon: IconSelector.ContactIcon,
        color: 'Blue'
    },
    {
        value: CONTACT_TYPE_DIRECCION,
        label: 'Dirección Envío',
        description: 'Direccion de Envio',
        icon: IconSelector.LogisticIcon,
        color: 'DarkOrange'
    }
];
